<template>
  <b-row class="d-flex">
    <b-col v-for="(chart, index) in chartData" 
           cols="12" 
           :lg="getColSize(index)" 
           class="pb-5 pb-lg-0" 
           style="min-width: 160px;"
           :class="chart.parentContainerClass"
    >
      <vue-element-loading :active="chart.loading" />
      <div :class="'chart-container ' + chart.containerClass"
           v-if="!chart.loading">
        <h5>{{ chart.title }}</h5>
        <data-pie 
            :ref="chart.ref"
            :chart-data="chart.chartData"
            :colours="chartColors"
            :options="chartOptions"
            :enable-centre-total="chart.enableCentreTotal"
            @click="$emit('click', $event)"
        >
        </data-pie>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import DataPie from '@/components/Charts/DataPie';

export default {
  name: 'DonutChartPanel',
  components: {
    DataPie,
  },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartColors: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
    },
  },
  methods: {
    getColSize(index) {
      if (index === 0) {
        return 4;
      }

      return 2;
    },
  }
};
</script>

<style scoped>

</style>
